/* eslint-disable max-len */
import React, { useState, useEffect, useMemo } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';
import PermitContent from './PermitContent';

const form = {
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  module_type: 'OHP',
};

const statusOptions = [
  { label: 'ALL STATUS', value: '' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'FOR APPEARANCE', value: 'FOR APPEARANCE' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'PRINTED', value: 'PRINTED' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'PROCESSING', value: 'PROCESSING' },
  { label: 'REJECTED', value: 'REJECTED' },
  { label: 'APPROVED', value: 'APPROVED' },
  { label: 'FOR CHECKING', value: 'FOR CHECKING' },
  { label: 'RECEIVED', value: 'RECEIVED' },
  { label: 'PAID', value: 'PAID' },
  { label: 'PENDING LAB TEST', value: 'PENDING LAB TEST' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
];

const filterOption = [
  { label: 'ALL', value: '' },
  { label: 'CERTIFICATE', value: 'CERTIFICATE' },
  { label: 'PERMIT', value: 'PERMIT' },
];

function Applications({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  approveTransaction,
  showTransaction,
  rejectTransaction,
  startAssessment,
  tagAsPrinted,
  tagAsReceived,
}) {
  const [formData, setFormData] = useState(form);
  const [refreshList, setRefreshList] = useState('');
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const transactionType = useMemo(() => {
    if (match.params.transaction_type.toUpperCase() === 'NEW') {
      return 'NEW';
    }
    return 'EDUCATIONAL INSTITUTION';
  }, [match.params]);

  const param = {
    module_type: 'OHP',
    q: formData.keyword ?? '',
    sort_by: 'asc',
    transaction_status: filter.transaction_status ?? '',
    is_generated: formData.is_generated ?? '',
    transaction_type: transactionType,
  };

  const debouncedSearchTerm = useDebounce(formData, 500);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setCountChar(e.target.value.length);
  };

  const handleOnSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
      is_generated: e.value,
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      transaction_status: e.value,
    });
    getTransactionList({ ...filter, transaction_status: e.value });
  };

  const handleApprove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Approve this application?',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        rejectTransaction(
          _.get(data, 'id'),
          {
            remarks,
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleTagAsPrinted = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to tag as printed this application?',
      (remarks) => {
        startAssessment(_.get(data, 'id'), () => {
          tagAsPrinted(
            _.get(data, 'id'),
            {
              remarks,
            },
            () => {
              showTransaction(_.get(data, 'id'));
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleTagAsReceived = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to tag as received this application?',
      (remarks) => {
        startAssessment(_.get(data, 'id'), () => {
          tagAsReceived(
            _.get(data, 'id'),
            {
              remarks,
            },
            () => {
              showTransaction(_.get(data, 'id'));
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const getExtName = (item) =>
    _.get(item, 'included.module.attributes.extension_name');

  useEffect(() => {
    if (refreshList) {
      showTransaction(refreshList);
    }
    setRefreshList('');
    if (debouncedSearchTerm && countChar >= 3) {
      setFilter({
        ...filter,
        keyword: formData.keyword,
        transaction_type: transactionType,
      });
    } else {
      setFilter({
        ...filter,
        transaction_type: transactionType,
      });
    }
    getTransactionList(param);
  }, [
    `${Object.values(filter).join(',')}`,
    transactionType,
    debouncedSearchTerm,
    refreshList,
  ]);

  useEffect(() => {
    setFormData((prevFormdata) => ({
      ...prevFormdata,
      keyword: '',
      q: '',
      is_generated: '',
    }));

    setFilter((prevFilter) => ({
      ...prevFilter,
      keyword: '',
      transaction_status: '',
    }));
  }, [transactionType, setFormData, setFilter]);

  return (
    <div className="card-content-listing pl-0">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            filterOption={filterOption}
            handleSelectFilter={handleOnSelect(_.get(formData, 'is_generated'))}
            certificateFilter={filter.transaction_status === 'APPROVED'}
            is_generated={_.get(formData, 'is_generated')}
            moduleName="Applications"
            getData={getTransactionList}
            setParams={param}
            setKeyword={handleOnChange}
            statusOptions={statusOptions}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'transaction_status')
            )}
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="Transaction List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {`${_.get(item, 'included.module.attributes.first_name')} ${
                    _.get(item, 'included.module.attributes.middle_name') || ''
                  } 
                  ${_.get(item, 'included.module.attributes.last_name')}  ${
                    getExtName(item) || ''
                  }`}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {' '}
                  {_.get(item, 'included.module.attributes.mobile_number')}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <PermitContent
                        onApprove={handleApprove}
                        onReject={handleReject}
                        onPrinted={handleTagAsPrinted}
                        onReceived={handleTagAsReceived}
                        refreshList={setRefreshList}
                        filter={filter}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

Applications.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  tagAsPrinted: PropTypes.instanceOf(Function).isRequired,
  tagAsReceived: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(Applications);
